import React, { useState, useEffect, useRef } from "react";
import {
  Navbar,
  Nav,
  Form,
  Button,
  Image,
  Dropdown,
  DropdownDivider,
  Overlay,
  Popover,
  Row,
  Col,
  Pagination,
  Table,
  DropdownItem,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faPlus } from "@fortawesome/free-solid-svg-icons";
import { debounce } from "lodash";
import search from "../../assets/search.svg";
import exportIcon from "../../assets/export-icon.svg";
import orderRoute from "../../services/orderRoute";
import { useAppContext } from "../../AppContext";
import edit from "../../assets/edit.svg";
import { useNavigate } from "react-router-dom";
import deleteIcon from "../../assets/delete.svg";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

import DeleteProductModal from "../../components/Modal/DeleteProductModal";
import { FiGift } from "react-icons/fi";

const AdminOrders = () => {
  const { showToast, showDeleteModal, setShowDeleteModal } = useAppContext();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [isExportOpen, setIsExportOpen] = useState(false);
  const [searchOrder, setSearchOrder] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [visualOrderStatus, setVisualOrderStatus] = useState("All");
  const [isDeliveryTypeOpen, setIsDeliveryTypeOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getAdminOrders, bulkStatusUpdate, filterOrdersByDate, filterOrders, exportOrders } =
    orderRoute();
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [orderDetails, setOrderDetails] = useState([]);
  const [orderDisplayDetails, setOrderDisplayDetails] = useState([]);
  const [orderStatus, setOrderStatus] = useState("All");
  const [exportFormat, setExportFormat] = useState(null);
  const [selectedOrdersId, setSelectedOrdersId] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [categories, setCategories] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isDateOpen, setIsDateOpen] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    startDate: null,
    endDate: null,
    status: null,
    deliveryType: null,
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    itemsPerPage: 20,
    totalPages: 0,
    totalOrders: 0,
  });
  const [currentOrder, setCurrentOrder] = useState(null);
  const [showExportDate, setShowExportDate] = useState(false);
  const [exportDate, setExportDate] = useState(new Date());
  const tableRef = useRef(null);
  const dropdownRef1 = useRef(null);
  const dropdownRef2 = useRef(null);
  const dropdownRef3 = useRef(null);
  const dropdownRef4 = useRef(null);
  const dropdownRef5 = useRef(null);
  const filtersInitialized = useRef(false);

  const statusQueryFilters = {
    created: { orderStatus: "order confirmed" },
    pending: { paymentStatus: "pending" },
    "out for delivery": { orderStatus: "out for delivery" },
    delivered: { orderStatus: "order delivered" },
  };

  const fetchOrders = (page = pagination.currentPage) => {
    getAdminOrders(
      setLoading,
      showToast,
      setOrderDetails,
      setOrderDisplayDetails,
      { ...pagination, currentPage: page },
      setPagination,
      { search: debouncedSearch, ...statusQueryFilters[orderStatus?.toLowerCase()] }
    );
  };

  useEffect(() => {
    fetchOrders();
  }, [pagination.currentPage, orderStatus, debouncedSearch]);

  function isEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
        setIsDateOpen(false);
      }
      if (dropdownRef3.current && !dropdownRef3.current.contains(event.target)) {
        setIsExportOpen(false);
      }
      if (dropdownRef4.current && !dropdownRef4.current.contains(event.target)) {
        setIsStatusOpen(false);
      }
      if (dropdownRef5.current && !dropdownRef5.current.contains(event.target)) {
        setIsDeliveryTypeOpen(false);
      }
    }

    function handleScroll() {
      setIsOpen(false);
      setIsOpen2(false);
      setIsStatusOpen(false);
      setIsDateOpen(false);
      setIsExportOpen(false);
      setIsDeliveryTypeOpen(false);
    }

    // Add event listeners
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      // Clean up
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  useEffect(() => {
    if (orderDisplayDetails?.length > 0) {
      const updatedOrderDisplayDetails = orderDisplayDetails?.map((orderDetail) => {
        let canModify = false;

        if (
          orderDetail?.cart?.length > 0 &&
          orderDetail?.deliveryDate &&
          orderDetail?.orderInfo?.length > 0
        ) {
          const lastOrderInfo = orderDetail?.orderInfo[orderDetail?.orderInfo?.length - 1];
          if (lastOrderInfo?.orderStatus?.toLowerCase() === "order confirmed") {
            const deliveryDate = new Date(orderDetail?.deliveryDate);
            deliveryDate.setDate(deliveryDate.getDate() - 1);
            deliveryDate.setHours(23, 0, 0, 0);
            const currentTime = new Date();
            if (currentTime < deliveryDate) {
              canModify = true;
            }
          }
        }

        return { ...orderDetail, canModify };
      });

      if (!isEqual(updatedOrderDisplayDetails, orderDisplayDetails)) {
        setOrderDisplayDetails(updatedOrderDisplayDetails);
      }
    }
  }, [orderDisplayDetails]);

  useEffect(() => {
    const applySearch = debounce(() => {
      const nextSearch = searchOrder.trim();
      if (nextSearch === debouncedSearch) return;
      setDebouncedSearch(nextSearch);
      setPagination((prev) => ({ ...prev, currentPage: 1 }));
    }, 1000);
    applySearch();
    return () => applySearch.cancel();
  }, [searchOrder]);

  useEffect(() => {
    const updatedActiveFilters = [];

    if (selectedFilters.startDate !== null) {
      updatedActiveFilters.push({
        type: "startDate",
        value: selectedFilters.startDate.toLocaleDateString("en-US", { timeZone: "Africa/Lagos" }),
      });
    }

    if (selectedFilters.endDate !== null) {
      updatedActiveFilters.push({
        type: "endDate",
        value: selectedFilters.endDate.toLocaleDateString("en-US", { timeZone: "Africa/Lagos" }),
      });
    }

    if (selectedFilters.status !== null) {
      updatedActiveFilters.push({
        type: "status",
        value: selectedFilters.status,
      });
    }

    if (selectedFilters.deliveryType !== null) {
      updatedActiveFilters.push({
        type: "deliveryType",
        value: selectedFilters.deliveryType,
      });
    }

    setActiveFilters(updatedActiveFilters);
  }, [selectedFilters]);

  const applyFilters = () => {
    let isoStartDate = "";
    let isoEndDate = "";
    let deliveryType = "";
    let orderStatusType = "";

    // Handle Start Date
    if (selectedFilters.startDate) {
      const startOfStartDate = new Date(
        Date.UTC(
          selectedFilters.startDate.getFullYear(),
          selectedFilters.startDate.getMonth(),
          selectedFilters.startDate.getDate(),
          0,
          0,
          0,
          0
        )
      );
      isoStartDate = startOfStartDate.toISOString();
    }

    // Handle End Date
    if (selectedFilters.endDate) {
      const startOfEndDate = new Date(
        Date.UTC(
          selectedFilters.endDate.getFullYear(),
          selectedFilters.endDate.getMonth(),
          selectedFilters.endDate.getDate(),
          0,
          0,
          0,
          0
        )
      );
      isoEndDate = startOfEndDate.toISOString();
    }

    // Handle Delivery Type
    if (selectedFilters.deliveryType === "Home Delivery") {
      deliveryType = "delivery";
    } else if (selectedFilters.deliveryType === "In-store Pickup") {
      deliveryType = "pickup";
    }

    // Handle Order Status
    if (selectedFilters.status) {
      const normalizedStatus = selectedFilters.status?.toLowerCase();
      if (normalizedStatus === "confirmed") {
        orderStatusType = "order confirmed";
      } else if (normalizedStatus === "processing") {
        orderStatusType = "order processing";
      } else if (normalizedStatus === "delivered") {
        orderStatusType = "order delivered";
      } else {
        orderStatusType = normalizedStatus;
      }
    }

    filterOrders(setLoading, setOrderDisplayDetails, showToast, pagination, setPagination, {
      isoStartDate,
      isoEndDate,
      orderStatusType,
      deliveryType,
    });
  };

  useEffect(() => {
    if (!filtersInitialized.current) {
      filtersInitialized.current = true;
      return;
    }
    if (
      selectedFilters.startDate ||
      selectedFilters.endDate ||
      selectedFilters.status ||
      selectedFilters.deliveryType
    ) {
      applyFilters(); // Apply filters whenever selectedFilters changes
    } else {
      fetchOrders();
    }
  }, [selectedFilters]);

  const handleStatusClick = (status) => {
    if (status === orderStatus && pagination.currentPage === 1) {
      fetchOrders(1);
    } else {
      setOrderStatus(status);
      setPagination((prev) => ({ ...prev, currentPage: 1 }));
    }
    setVisualOrderStatus(status);
    setIsStatusOpen(false);
  };

  // const handleFilter = () => {
  //   const startOfStartDate = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0));
  //   const isoStartDate = startOfStartDate.toISOString();

  //   // Set the end date to the beginning of the day in UTC
  //   const startOfEndDate = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0, 0));
  //   const isoEndDate = startOfEndDate.toISOString();
  //   setIsDateOpen(false);
  //   filterOrdersByDate(isoEndDate, isoStartDate, setLoading, setOrderDisplayDetails, setVisualOrderStatus, showToast);
  //  // Close the date picker dropdown
  // };

  const formatDateToLongForm = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "Africa/Lagos",
    });
  };

  const prepareCSVData = () => {
    // Legacy CSV export data preparation - kept if needed for reference, but currently unused
    return null;
  };

  const toggleDropdown = () => setIsOpen(!isOpen);
  const toggleDropdown2 = () => setIsOpen2(!isOpen2);

  const toggleStatusDropdown = () => setIsStatusOpen(!isStatusOpen);
  const toggleDeliveryOpen = () => setIsDeliveryTypeOpen(!isStatusOpen);
  const toggleExportDropdown = () => setIsExportOpen(!isExportOpen);
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };
  const handlePageChange = (page) => {
    setPagination((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };
  const handleCheckboxChange = (orderId, isChecked, event) => {
    if (isChecked) {
      setSelectedOrdersId((prevIds) => [...prevIds, orderId]);
    } else {
      setSelectedOrdersId((prevIds) => prevIds.filter((id) => id !== orderId));
    }
  };

  const capitalizeFirstLetter = (string) => {
    return string?.replace(/\b(\w)/g, (s) => s.toUpperCase());
  };
  const getStatusStyle = (status) => {
    switch (status) {
      case "order confirmed":
        return {
          backgroundColor: "white",
          color: "#194298",
          border: "1px solid #194298",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "order delivered":
        return {
          backgroundColor: "white",
          color: "#08875D",
          border: "1px solid #08875D",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "order picked up":
        return {
          backgroundColor: "white",
          color: "#08875D",
          border: "1px solid #08875D",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "out for delivery":
        return {
          backgroundColor: "white",
          color: "#F2994A",
          border: "1px solid #F2994A",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "ready for pickup":
        return {
          backgroundColor: "white",
          color: "#F2994A",
          border: "1px solid #F2994A",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "order processing":
        return {
          backgroundColor: "white",
          color: "#B25E09",
          border: "1px solid #B25E09",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
      case "awaiting payment":
        return {
          backgroundColor: "white",
          color: "#FD7B1D",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
          border: "1px solid #FD7B1D",
        };
      default:
        return {
          backgroundColor: "white",
          color: "#B25E09",
          border: "1px solid #FEF1F2",
          padding: "6px 16px 6px 16px",
          borderRadius: "16px",
        };
    }
  };

  const determineStatus = (order) => {
    let statusText = "Status Unknown";
    let statusStyle = { backgroundColor: "grey", color: "white" };

    if (Array.isArray(order?.orderInfo) && order?.orderInfo.length > 0) {
      const lastStatusObj = order?.orderInfo[order?.orderInfo.length - 1]; // Get the last object
      statusText = capitalizeFirstLetter(lastStatusObj.orderStatus); // Assuming capitalizeFirstLetter function capitalizes each word correctly
    } else if (order?.paymentStatus === "pending") {
      statusText = "Awaiting Payment"; // This is already properly capitalized
    } else if (order?.source === "voucher") {
      statusText = "Order Confirmed";
    }

    statusStyle = getStatusStyle(statusText?.toLowerCase()); // Ensure status style is determined correctly
    return <span style={statusStyle}>{statusText}</span>;
  };

  const truncateText = (text, maxLength = 20) => {
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };
  const handleCreate = () => {
    navigate("/admin/orders/create");
  };

  // const handleDeliveryClick = (delivery) => {
  //   let filteredOrders;
  //   if (delivery === 'Home Delivery') {
  //     filteredOrders = globalOrders.filter(order => order.deliveryType === 'delivery');
  //   } else if (delivery === 'In-store Pickup') {
  //     filteredOrders = globalOrders.filter(order => order.deliveryType === 'pickup');
  //   }
  //   setOrderDisplayDetails(filteredOrders);
  //   setPagination({
  //     currentPage: 1,
  //     itemsPerPage: 20,
  //     totalPages: 0,
  //     totalOrders: 0,
  //   })
  // };
  const pickupStatuses = new Set([
    "order picked up",
    "ready for pickup",
    "order processing",
    "order confirmed",
  ]);
  const deliveryStatuses = new Set([
    "order delivered",
    "out for delivery",
    "order processing",
    "order confirmed",
  ]);
  const statusTransitions = {
    pickup: {
      "order confirmed": "order processing",
      "order processing": "ready for pickup",
      "ready for pickup": "order picked up",
    },
    delivery: {
      "order confirmed": "order processing",
      "order processing": "out for delivery",
      "out for delivery": "order delivered",
    },
  };

  const handleStatusUpdate = (status) => {
    if (selectedOrdersId.length === 0) {
      showToast({ toastText: "No orders selected for status update.", isSuccess: false });
      return;
    }
    const lowerCaseStatus = status?.toLowerCase();
    const invalidOrders = [];
    const outOfSequenceOrders = [];

    const ordersToUpdate = selectedOrdersId
      .map((orderId) => {
        const order = orderDisplayDetails?.find((detail) => detail?._id === orderId);

        if (!order) return null;

        // Check if the new status is valid for the current delivery type
        if (
          (order.deliveryType === "pickup" && !pickupStatuses.has(lowerCaseStatus)) ||
          (order.deliveryType === "delivery" && !deliveryStatuses.has(lowerCaseStatus))
        ) {
          invalidOrders.push(order);
          return null;
        }

        // Check sequence of status update
        const currentStatus =
          order?.orderInfo && order?.orderInfo.length > 0
            ? order?.orderInfo[order?.orderInfo?.length - 1].orderStatus?.toLowerCase()
            : null;
        const validNextStatus = statusTransitions[order.deliveryType]?.[currentStatus];

        if (!validNextStatus || validNextStatus !== lowerCaseStatus) {
          outOfSequenceOrders.push(order);
          return null;
        }

        return {
          orderId: orderId,
          email: order?.user ? order?.user?.email : order?.metaData?.email,
        };
      })
      .filter((order) => order !== null);

    // Notify user of invalid orders by delivery type
    if (invalidOrders.length > 0) {
      showToast({
        toastText:
          "Invalid status update. Please ensure the orders delivery type matches the status",
        isSuccess: false,
      });
      return;
    }

    if (outOfSequenceOrders.length > 0) {
      const expectedNextStatus =
        statusTransitions[outOfSequenceOrders[0].deliveryType][
          outOfSequenceOrders[0].orderInfo[
            outOfSequenceOrders[0].orderInfo.length - 1
          ].orderStatus?.toLowerCase()
        ];
      showToast({
        toastText: `Out of sequence status update. The expected next status should be ${capitalizeFirstLetter(expectedNextStatus)}.`,
        isSuccess: false,
      });
      return;
    }

    // Proceed with the update if all checks pass
    if (ordersToUpdate.length > 0) {
      const body = {
        ordersToUpdate: ordersToUpdate,
        status: lowerCaseStatus,
      };

      bulkStatusUpdate(body, setLoading, showToast, setSelectedOrdersId);
    } else {
      showToast({ toastText: "No valid orders to update.", isSuccess: false });
    }
  };

  const handleModifyOrderClick = (orderId) => {
    navigate(`/admin/orders/modification/${orderId}`);
  };
  const handleFilterChange = (type, value) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [type]: prevFilters[type] === value ? null : value,
    }));
  };

  const handleRemoveFilter = (type) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [type]: null,
    }));
  };

  const clearFilters = () => {
    setSelectedFilters({
      startDate: null,
      endDate: null,
      status: null,
      deliveryType: null,
    });
    setActiveFilters([]);
    setOrderStatus("All");
    setVisualOrderStatus("All");
    setStartDate(new Date());
    setEndDate(new Date());
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  return (
    <section className="list-page">
      <div className="d-flex justify-content-between align-items-center header-admin py-5 pe-5 ps-4">
        <h3 style={{ color: "#344054" }}>Orders</h3>
        <div className="d-flex gap-3">
          <Dropdown
            show={isExportOpen}
            ref={dropdownRef3}
            onToggle={(nextShow) => {
              setIsExportOpen(nextShow);
              if (!nextShow) setShowExportDate(false);
            }}
          >
            <Button
              variant="secondary"
              id="dropdown-basic"
              style={{ fontWeight: "500", color: "#333333" }}
              onClick={toggleExportDropdown}
              className="d-flex align-items-center gap-4 "
            >
              Export
              <img src={exportIcon} />
            </Button>
            <Dropdown.Menu style={{ minWidth: "250px" }}>
              <Dropdown.Item
                onClick={() => {
                  exportOrders("", setLoading, showToast);
                  setIsExportOpen(false);
                }}
              >
                Export All
              </Dropdown.Item>
              <DropdownDivider />
              <Dropdown.Item
                onClick={(e) => {
                  e.stopPropagation();
                  setShowExportDate(!showExportDate);
                }}
              >
                Export Per Delivery Date
              </Dropdown.Item>

              {showExportDate && (
                <>
                  <DropdownDivider />
                  <div className="p-3">
                    <Form.Group>
                      <Form.Label style={{ fontWeight: "500", color: "#344054" }}>
                        Delivery Date
                      </Form.Label>
                      <DatePicker
                        selected={exportDate}
                        onChange={(date) => {
                          setExportDate(date);
                        }}
                        className="form-control w-100"
                        style={{ overflowX: "hidden" }}
                      />
                    </Form.Group>
                    <Button
                      className="mt-3 w-100"
                      style={{
                        backgroundColor: "#5D824E",
                        border: "none",
                        fontWeight: "600",
                      }}
                      onClick={() => {
                        const startOfExportDate = new Date(
                          Date.UTC(
                            exportDate.getFullYear(),
                            exportDate.getMonth(),
                            exportDate.getDate(),
                            0,
                            0,
                            0,
                            0
                          )
                        );
                        const isoDateString = startOfExportDate.toISOString();
                        exportOrders(isoDateString, setLoading, showToast);
                        setIsExportOpen(false);
                        setShowExportDate(false);
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>

          <Button className="d-flex align-items-center gap-3 p-2" onClick={handleCreate}>
            <FontAwesomeIcon icon={faPlus} />
            Create Order
          </Button>
        </div>
      </div>
      <div className="d-flex gap-5 pt-2 my-3 ps-4" style={{ borderBottom: "1px solid #EDEDED" }}>
        {["All", "Created", "Pending", "Out for Delivery", "Delivered"].map((status, index) => (
          <p
            key={index}
            className={`order-item pb-2 mb-0 me-4 ${visualOrderStatus === status ? "active" : ""}`}
            onClick={() => handleStatusClick(status)}
            style={{ cursor: "pointer", marginBottom: "5px" }}
          >
            {status}&nbsp; Orders
          </p>
        ))}
      </div>
      <div className="ps-4 pe-5">
        <div className="d-flex align-items-center justify-content-between py-4 ">
          <div className="d-flex align-items-center gap-5">
            {selectedOrdersId.length > 0 ? (
              <Form.Check
                checked
                label={`${selectedOrdersId.length} selected`}
                className="selected-check"
              />
            ) : (
              <p style={{ color: "#1D2939", fontWeight: "500" }} className="my-auto">
                {pagination?.totalOrders
                  ? pagination?.totalOrders
                  : orderDisplayDetails?.length}{" "}
                {pagination?.totalOrders?.length > 1 || orderDisplayDetails?.length > 1
                  ? "Orders"
                  : "Order"}
              </p>
            )}

            {selectedOrdersId.length > 0 && (
              <Dropdown show={isOpen} ref={dropdownRef1}>
                <Button
                  variant="secondary"
                  id="dropdown-basic"
                  onClick={toggleDropdown}
                  className="d-flex align-items-center gap-2 p-2"
                  style={{ fontWeight: "500", color: "#333333", fontSize: "12px" }}
                >
                  Update Status <FontAwesomeIcon icon={faChevronDown} />
                </Button>

                <Dropdown.Menu>
                  {[
                    "Order Delivered",
                    "Out for Delivery",
                    "Order Picked up",
                    "Ready for Pickup",
                    "Order Processing",
                    "Order Confirmed",
                  ].map((status, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => {
                        handleStatusUpdate(status);
                        toggleDropdown();
                      }}
                    >
                      {" "}
                      {status}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            )}
            <div
              className="d-flex align-items-center position-relative search-bar py-1 px-1"
              style={{ border: "1px solid #D9D9D9", fontWeight: "500", width: "300px" }}
            >
              {!isFocused && searchOrder === "" && (
                <>
                  <img
                    src={search}
                    alt="search"
                    style={{ top: "24%", left: "1.5%" }}
                    className="position-absolute"
                  />
                </>
              )}
              {searchOrder !== "" && (
                <i
                  className="bi bi-x"
                  style={{
                    top: "5%",
                    right: "1.5%",
                    position: "absolute",
                    fontSize: "1.5rem",
                    color: "#98A2B3",
                  }}
                  onClick={() => setSearchOrder("")}
                ></i>
              )}
              <Form.Control
                style={{ border: "none", backgroundColor: "transparent" }}
                placeholder="Search by customer name"
                className="w-100"
                value={searchOrder}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={(e) => setSearchOrder(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex gap-3">
            {/* <Button variant='secondary' className='d-flex align-items-center gap-4' style={{fontWeight:'500', color:'#333333'}}>Filter<FontAwesomeIcon icon={faChevronDown} style={{fontSize:'0.8rem'}}/></Button> */}
            <Dropdown show={isDateOpen} ref={dropdownRef2}>
              {/* <Button variant='secondary' id="dropdown-basic"  onClick={toggleDropdown2} className='d-flex align-items-center gap-4'  style={{fontWeight:'500', color:'#333333'}}>
   Filter By Date <FontAwesomeIcon icon={faChevronDown} />
   </Button> */}
              <Button
                variant="secondary"
                id="dropdown-basic"
                onClick={() => setIsDateOpen(!isDateOpen)}
                className="d-flex align-items-center gap-1"
                style={{ fontWeight: "500", color: "#333333" }}
              >
                Date{" "}
                {isDateOpen ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} />
                )}
              </Button>

              <Dropdown.Menu className="me-5">
                {isDateOpen && (
                  <div
                    className="d-flex flex-column gap-3 p-3 "
                    style={{ width: "180px", overflowX: "hidden" }}
                  >
                    <Form.Group>
                      <Form.Label>Start Date</Form.Label>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          setSelectedFilters({ ...selectedFilters, startDate: date });
                        }}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        className="w-100"
                        style={{ overflowX: "hidden" }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>End Date</Form.Label>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => {
                          setEndDate(date);
                          setSelectedFilters({ ...selectedFilters, endDate: date });
                        }}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="w-100"
                        style={{ overflowX: "hidden" }}
                      />
                    </Form.Group>

                    {/* <Button className='text-center w-30' onClick={handleFilter}>Filter</Button> */}
                  </div>
                )}
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown show={isStatusOpen} ref={dropdownRef4}>
              <Button
                variant="secondary"
                id="dropdown-basic"
                onClick={toggleStatusDropdown}
                className="d-flex align-items-center gap-1"
                style={{ fontWeight: "500", color: "#333333" }}
              >
                Status{" "}
                {isStatusOpen ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} />
                )}
              </Button>

              <Dropdown.Menu className="px-2" style={{ width: "200px" }}>
                {isStatusOpen &&
                  [
                    "Confirmed",
                    "Processing",
                    "Out for Delivery",
                    "Ready for Pickup",
                    "Order Picked Up",
                    "Delivered",
                  ].map((status, index) => (
                    // <Dropdown.Item
                    //   key={index}

                    //   onClick={() => {handleStatusClick(status); toggleDropdown2()}}
                    // > {status}
                    // </Dropdown.Item>

                    <Form.Check
                      key={index}
                      type="checkbox"
                      label={status}
                      checked={selectedFilters.status === status}
                      onChange={() => {
                        toggleStatusDropdown();
                        handleFilterChange("status", status);
                      }}
                    />
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown show={isDeliveryTypeOpen} ref={dropdownRef5}>
              <Button
                variant="secondary"
                id="dropdown-basic"
                onClick={toggleDeliveryOpen}
                className="d-flex align-items-center gap-1"
                style={{ fontWeight: "500", color: "#333333" }}
              >
                Delivery Type{" "}
                {isDeliveryTypeOpen ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} />
                )}
              </Button>

              <Dropdown.Menu className="px-2">
                {isDeliveryTypeOpen &&
                  ["Home Delivery", "In-store Pickup"].map((delivery, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      label={delivery}
                      checked={selectedFilters.deliveryType === delivery}
                      onChange={() => {
                        toggleDeliveryOpen();
                        handleFilterChange("deliveryType", delivery);
                      }}
                    />
                    //  <Dropdown.Item
                    //   key={index}

                    //   onClick={() => {handleDeliveryClick(delivery); toggleDeliveryOpen()}}
                    // > {delivery}
                    // </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="my-2 d-flex ">
          {activeFilters.length > 0 && (
            <div className="d-flex gap-2 align-items-center">
              <h6 style={{ fontWeight: "500" }} className="my-2">
                Filter by:
              </h6>
              {activeFilters.map((filter, index) => (
                <Button
                  key={index}
                  classNameame=""
                  style={{
                    borderRadius: "20px",
                    fontSize: "14px",
                    border: "1px solid #4F4F4F4D",
                    backgroundColor: "#EAEAEA33",
                    color: "#333333",
                    fontWeight: "500",
                  }}
                >
                  {filter.value} &nbsp;{" "}
                  <span
                    className="px-1 py-0 align-items-center"
                    style={{ borderRadius: "50%", border: "1px solid #333333" }}
                    onClick={() => handleRemoveFilter(filter.type)}
                  >
                    x
                  </span>
                </Button>
              ))}
              <Button
                className="apply-filters-button"
                onClick={clearFilters}
                disabled={activeFilters.length === 0}
                style={{ fontSize: "14px", backgroundColor: "#4F4F4F", color: "#FFFFFF" }}
              >
                Reset Filter
              </Button>
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <div
          className="justify-content-center align-items-center text-center"
          style={{ padding: "100px" }}
        >
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : orderDisplayDetails?.length > 0 ? (
        <div className="ps-4 pe-5 list-body">
          <div className="list-scroll">
            <Table hover className="my-3 d-none" ref={tableRef}>
              <thead>
                <tr style={{ fontWeight: "600" }} className="mb-2">
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Order ID
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Customer Name
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Email
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Phone Number
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Status
                  </th>

                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Order Date
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Cart Items
                  </th>

                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Delivery Area
                  </th>

                  <th style={{ fontWeight: "600" }} className="pb-3">
                    {" "}
                    Total Price
                  </th>

                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Pickup/Delivery Date
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Payment Method
                  </th>

                  <th style={{ fontWeight: "600" }} className="pb-3">
                    {" "}
                    Transaction ID
                  </th>
                </tr>
              </thead>
              <tbody className="py-2">
                {orderDisplayDetails?.map((order) => (
                  <tr
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#333333",
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                    key={order?._id}
                  >
                    <td
                      style={{
                        paddingTop: "15px",
                        paddingBottom: "15px",
                        color: "#194298",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => navigate(`/admin/orders/${order?._id}`)}
                    >
                      {truncateText(`${order?.sku ? order?.sku : order?._id}`)}
                    </td>

                    {order?.user ? (
                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                          color: "#194298",
                          cursor: "pointer",
                        }}
                      >
                        {order?.user?.firstName}&nbsp;{order?.user?.lastName}
                      </td>
                    ) : (
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        {order?.metaData?.userName}
                      </td>
                    )}

                    {order?.user ? (
                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                          color: "#194298",
                          cursor: "pointer",
                        }}
                      >
                        {order?.user?.email}
                      </td>
                    ) : (
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        {order?.metaData?.email}
                      </td>
                    )}

                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.phoneNumber}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {determineStatus(order)}
                    </td>

                    {order.orderInfo && order.orderInfo.length > 0 ? (
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        {formatDateToLongForm(order.orderInfo[0].time)}
                      </td>
                    ) : (
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>N/A</td>
                    )}
                    <td>
                      {order?.cart
                        ?.map((item) => `${item?.productId?.productName} (${item?.quantity})`)
                        .join("; ") || "-"}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {" "}
                      {order?.deliveryType === "delivery" &&
                      order?.address &&
                      Object.keys(order?.address)?.length > 0
                        ? capitalizeFirstLetter(
                            ` ${order?.address?.city?.name ? `${order?.address?.city?.name}, ` : ""} ${order?.address?.state?.name} `
                          )
                        : order?.deliveryType === "pickup"
                          ? "In-store pickup"
                          : "Gift Voucher"}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.totalCost?.toLocaleString() || order?.amount?.toLocaleString()}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {" "}
                      {order?.deliveryDate
                        ? formatDateToLongForm(order?.deliveryDate)
                        : "Gift Voucher"}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.paymentMethod || "-"}
                    </td>

                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.transactionReference || order?.transaction || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Table hover className="my-3" id="order-table">
              <thead>
                <tr style={{ fontWeight: "600" }} className="mb-2">
                  <th style={{ fontWeight: "600" }} className="pb-3"></th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Order ID
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Customer Name
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    {" "}
                    Price
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Delivery Area
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Delivery Date
                  </th>
                  <th style={{ fontWeight: "600" }} className="pb-3">
                    Status
                  </th>

                  <th style={{ fontWeight: "600" }} className="pb-3"></th>
                </tr>
              </thead>
              <tbody className="py-2">
                {orderDisplayDetails?.map((order) => (
                  <tr
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#333333",
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                    key={order?._id}
                  >
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.source !== "voucher" &&
                        order.orderInfo &&
                        order.orderInfo.length > 0 &&
                        order.orderInfo[order.orderInfo.length - 1].orderStatus?.toLowerCase() !==
                          "order delivered" &&
                        order.orderInfo[order.orderInfo.length - 1].orderStatus?.toLowerCase() !==
                          "order picked up" && (
                          <div>
                            <Form.Check
                              checked={selectedOrdersId.includes(order._id)}
                              onChange={(e) => {
                                handleCheckboxChange(order._id, e.target.checked);
                              }}
                            />
                          </div>
                        )}
                    </td>
                    <td
                      style={{
                        paddingTop: "15px",
                        paddingBottom: "15px",
                        color: "#194298",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => navigate(`/admin/orders/${order?._id}`)}
                    >
                      {truncateText(`${order?.sku ? order?.sku : order?._id}`)}
                    </td>
                    {order?.user ? (
                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                          color: "#194298",
                          cursor: "pointer",
                        }}
                      >
                        {order?.user?.firstName}&nbsp;{order?.user?.lastName}
                      </td>
                    ) : (
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        {order?.metaData?.userName}
                      </td>
                    )}

                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {" "}
                      {order?.totalCost?.toLocaleString() || order?.amount?.toLocaleString()}{" "}
                      {order?.hasFreeGift && <FiGift size={20} color="#469B12" />}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.deliveryType === "delivery" &&
                      order?.address &&
                      Object.keys(order?.address)?.length > 0
                        ? capitalizeFirstLetter(
                            `${order?.address?.city?.name ? `${order?.address?.city?.name}, ` : ""}${order?.address?.state?.name}`
                          )
                        : order?.deliveryType === "pickup"
                          ? "In-store pickup"
                          : "Gift Voucher"}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {formatDateToLongForm(order?.deliveryDate)}
                    </td>
                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {determineStatus(order)}
                    </td>

                    <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                      {order?.canModify && (
                        <>
                          <img
                            src={edit}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleModifyOrderClick(order?._id);
                            }}
                          />{" "}
                          &nbsp;&nbsp;{" "}
                        </>
                      )}{" "}
                      {order?.orderInfo &&
                        order?.orderInfo.length > 0 &&
                        order?.orderInfo[order?.orderInfo.length - 1].orderStatus?.toLowerCase() ===
                          "order confirmed" && (
                          <img
                            src={deleteIcon}
                            onClick={() => {
                              setCurrentOrder(order);
                              setShowDeleteModal(true);
                            }}
                          />
                        )}
                    </td>
                    {/* <td style={{paddingTop: '15px', paddingBottom: '15px',cursor:'pointer', textDecoration:'underline', color:'#469B12'}} onClick={() => navigate(`/admin/orders/${order?._id}`)}>View</td> */}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {orderDetails.length > 0 && pagination.totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center py-3">
              <p style={{ fontWeight: "500", color: "#919EAB" }}>
                Showing {orderDetails.length} of {pagination.totalOrders} products
              </p>
              {pagination.totalPages > 1 && (
                <Pagination className="custom-pagination d-flex gap-2">
                  <button
                    className="btn btn-outline-secondary pb-0 px-2"
                    disabled={pagination.currentPage === 1}
                    onClick={() => handlePageChange(pagination.currentPage - 1)}
                    style={{
                      border: pagination.currentPage === 1 ? "none" : "1px solid #C4CDD5",
                      color: pagination.currentPage === 1 ? "#C4CDD5" : "#000000",
                    }}
                  >
                    <h6>
                      <i className="bi bi-chevron-left"></i>
                    </h6>
                  </button>

                  {/* First Page */}
                  <Pagination.Item
                    onClick={() => handlePageChange(1)}
                    active={pagination.currentPage === 1}
                  >
                    1
                  </Pagination.Item>

                  {/* Ellipsis and Page Number Logic */}
                  {pagination.totalPages > 1 && (
                    <>
                      {pagination.currentPage > 3 && <Pagination.Ellipsis disabled />}

                      {/* Previous Page */}
                      {pagination.currentPage > 2 && (
                        <Pagination.Item
                          onClick={() => handlePageChange(pagination.currentPage - 1)}
                        >
                          {pagination.currentPage - 1}
                        </Pagination.Item>
                      )}

                      {/* Current Page */}
                      {pagination.currentPage !== 1 &&
                        pagination.currentPage !== pagination.totalPages && (
                          <Pagination.Item active>{pagination.currentPage}</Pagination.Item>
                        )}

                      {/* Next Page */}
                      {pagination.currentPage < pagination.totalPages - 1 && (
                        <Pagination.Item
                          onClick={() => handlePageChange(pagination.currentPage + 1)}
                        >
                          {pagination.currentPage + 1}
                        </Pagination.Item>
                      )}

                      {pagination.currentPage < pagination.totalPages - 2 && (
                        <Pagination.Ellipsis disabled />
                      )}

                      {/* Last Page */}
                      <Pagination.Item
                        onClick={() => handlePageChange(pagination.totalPages)}
                        active={pagination.currentPage === pagination.totalPages}
                      >
                        {pagination.totalPages}
                      </Pagination.Item>
                    </>
                  )}

                  <button
                    className="btn btn-outline-secondary pb-0 px-2"
                    disabled={pagination.currentPage === pagination.totalPages}
                    onClick={() => handlePageChange(pagination.currentPage + 1)}
                    style={{
                      border:
                        pagination.currentPage === pagination.totalPages
                          ? "none"
                          : "1px solid #C4CDD5",
                      color:
                        pagination.currentPage === pagination.totalPages ? "#C4CDD5" : "#000000",
                    }}
                  >
                    <h6>
                      <i className="bi bi-chevron-right"></i>
                    </h6>
                  </button>
                </Pagination>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="fw-medium px-5 py-5 ">
          <h4>{debouncedSearch ? "No orders match your search" : "You have no orders"}</h4>
        </div>
      )}

      <DeleteProductModal item={currentOrder} itemType="order" actionType="delete" />
    </section>
  );
};

export default AdminOrders;
